const loadUserInformation = () => {
  try {
    const user = localStorage.getItem('user');
    if (user) {
      return JSON.parse(user);
    }
  } catch (error) {
    return null;
  }
  return null
};

const saveUserInformation = (user) => {
  try {
    localStorage.setItem('user', JSON.stringify(user));
  } catch (error) {
    return false;

  }
};

const clearUserInformation = () => {
  try {
    localStorage.removeItem('user');
    return true;
  } catch (error) {
    return false;
  }
};

// Define initial state
const initialState = loadUserInformation() ?? {
  fullName: '',
  userId: '',
  email: '',
  status: 0,
  plan: null,
};

// Define action types
const SET_USER_INFORMATION = 'SET_USER_INFORMATION';
const REMOVE_USER_INFORMATION = 'REMOVE_USER_INFORMATION';

// Define reducer function
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_INFORMATION: {
      const user = {
        fullName: action.payload.fullName,
        userId: action.payload.userId,
        email: action.payload.email,
        status: action.payload.status,
        plan: action.payload.plan
      };
      saveUserInformation(user);
      return {
        ...state,
        ...user
      }
    }
    case REMOVE_USER_INFORMATION: {
      clearUserInformation();
      return {
        fullName: '',
        userId: '',
        email: '',
        status: 0,
        plan: null,
      };
    }
    default:
      return state;
  }
};


// Action creators
const setUserInformation = (fullName = '', userId = '', email = '', status = 0, plan = null) => ({
  type: SET_USER_INFORMATION,
  payload: { fullName, userId, email, status, plan }
});

const removeUserInformation = () => ({
  type: REMOVE_USER_INFORMATION
});

export { setUserInformation, removeUserInformation };
export default userReducer;
